import { Button, Grid, TextField } from '@mui/material';
import * as React from 'react';
import { useHistory } from "react-router-dom";
import { BasePageStyles } from '../../hooks/styles';
import { IMAGES_URL } from '../../constants/Images';
import Api from '../../redux/lib/api';
import { LOGIN } from '../../redux/constants/api.url';
import { default as ProductThumb } from '../../components/productThumb';
import { PRODUCTS } from '../../constants/Products';
import config from '../../config';


interface BrowseProps {}

export const BrowseComponent: React.FC<BrowseProps> = (props) => {
	const classes = BasePageStyles();
	const history = useHistory(); 

	<img src={IMAGES_URL.NARCAN_LANDING} style={{maxWidth: '100%'}}/>

	const routeChange = (path: string) =>{ 
	 	history.push(path);
	 }

	const products = PRODUCTS;

	return (
		<div style={{width: '100%', textAlign: 'center'}}>
			
				<h2>Select a product below to learn more or purchase.</h2>
				<ul className={classes.productsList}>
					{
						products.map((thisProduct) => {
							return (thisProduct.hideOnProd && config.environment === 'prod') ?
							null
							:
							 <li key={thisProduct.id}>
								<ProductThumb productInfo={thisProduct} />
							</li>
						})	
					}
				</ul>
			
		</div>
	)
}